// ── Enums ──

export enum Terrain {
  Prairie = "prairie",
  Forest = "forest",
  Mountain = "mountain",
  Lake = "lake",
}

export enum Animal {
  Sheep = "sheep",
  Deer = "deer",
  Wolf = "wolf",
  Bear = "bear",
}

export enum EdgeType {
  Land = "land",
  Water = "water",
  Cliff = "cliff",
}

export enum Direction {
  N = 0,
  E = 1,
  S = 2,
  W = 3,
}

export enum GameResult {
  Victory = "victory",
  MinorVictory = "minor_victory",
  Defeat = "defeat",
}

// ── Interfaces ──

export interface Edges {
  [Direction.N]: EdgeType
  [Direction.E]: EdgeType
  [Direction.S]: EdgeType
  [Direction.W]: EdgeType
}

export interface Position {
  row: number
  col: number
}

export interface TileData {
  terrain: Terrain
  animal: Animal | null
  baseEdges: Edges
  rotation: number // 0, 1, 2, 3 (quarter turns)
}

export interface TileDefinition {
  terrain: Terrain
  animal: Animal | null
  edgePattern: string // key into EDGE_PATTERNS
  count: number
}

export interface LevelConfig {
  level: number
  gridSize: number
  deckTiles: number
  marketSize: number
  description: string
}

export interface BFSNode {
  pos: Position
  distance: number
  consecutiveMountains: number
}

export interface PredationResult {
  kills: { pos: Position; animal: Animal }[]
  herbivoreDeaths: number
}

export interface TurnResult {
  placementScore: number
  predationResult: PredationResult
  penaltyScore: number
  comboReset: boolean
  turnScore: number
}

export interface EndGameScore {
  placementTotal: number
  animalScore: number
  perfectIslandScore: number
  penaltyTotal: number
  finalScore: number
  sheepSurvivalRate: number
  result: GameResult
}
